export default __webpack_public_path__ + "static/media/hubstaff.1fe1a2bf.svg";